import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppBubble } from "@/components/Social";
import Home from "@/pages/Home";
import Configurator from "@/pages/Configurator";
import Tracking from "@/pages/Tracking";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";
import Models from "@/pages/Models";
import { isShopifyEmbed } from "@/lib/embed";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname, search]);
  return null;
};

function App() {
  const embed = isShopifyEmbed();
  return (
    <div className={`App bg-[#F6F0EB] ${embed ? "" : "min-h-screen"}`}>
      <BrowserRouter>
        <ScrollToTop />
        {!embed && <Header />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/configurateur" element={<Configurator />} />
          <Route path="/suivi" element={<Tracking />} />
          <Route path="/suivi/:token" element={<Tracking />} />
          <Route path="/cgv" element={<Terms />} />
          <Route path="/atelier" element={<Admin />} />
          <Route path="/modeles" element={<Models />} />
          <Route path="/modeles/:id" element={<Models />} />
        </Routes>
        {!embed && <><Footer /><WhatsAppBubble /></>}
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
